import "./Counter.css";
import CountUp from "react-countup";

const Counter = () => {  
  return (
    <>
      <section className="Counter_section">
        <div className="container">
            
          <section className="home-counter-section">
            <div className="row">
              <div className="col-md-4">
                <div className="counter-div">
                  <div className=" my-auto">
                    <div className="number-div my-auto">
                      <h4 className="count-num">
                        <CountUp
                          start={0}
                          end={10000}
                          duration={10}
                          decimals={0}
                        />
                        +
                      </h4>
                      <p className="count-name">Total Followers</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="counter-div">
                  <div className=" my-auto">
                    <div className="number-div my-auto">
                      <h4 className="count-num">
                        <CountUp
                          start={0}
                          end={5000}
                          duration={10}
                          decimals={0}
                        />
                        +
                      </h4>
                      <p className="count-name">Total Shops</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="counter-div">
                  <div className=" my-auto">
                    <div className="number-div my-auto">
                      <h4 className="count-num">4.5 /5</h4>
                      <p className="count-name">Google Ratings</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </>
  );
};

export default Counter;
